import { jsx as r } from "react/jsx-runtime";
import d from "../../utils/classNames.js";
const t = ({ className: a = "", children: o, ...s }) => {
  const l = d("modal-body", a);
  return /* @__PURE__ */ r("div", { ...s, className: l, "aria-label": "dialog body", children: o });
};
export {
  t as default
};
//# sourceMappingURL=DialogBody.js.map
